<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" @refresh="onRefresh">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Piano</label>
                        <b-form-select v-model="filtroGestioneCamere.nomePiano" type="search" placeholder="Inserire piano" :options="pianiOptions" @change="onChangePiano">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona piano - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stanza</label>
                        <b-form-select v-model="filtroGestioneCamere.nomeStanza" type="search" placeholder="Inserire stanza" :options="stanzeOptions" @change="onChangeStanza">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona una stanza - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.nome" type="search" placeholder="Inserire letto" :options="lettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un letto - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Sesso</label>
                        <b-form-select v-model="filtroGestioneCamere.codiceSesso" text-field="descrizione" value-field="codice" type="search" placeholder="Inserire sesso" :options="sessoOptions" @change="onChangeSesso">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un sesso- </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Stato Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.statoAttuale" text-field="stato" value-field="stato" type="search" placeholder="Inserire sesso" :options="statoLettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Stato Letto -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <b-tabs id="tabsGestioneCamere" ref="tabsGestioneCamere" nav-wrapper-class="sa-tab-items" content-class="" class="sa-tab" fill @input="onChangeTab" v-model="activeTabIndex">
                <b-tab title="Gestione Camere" id="gestioneCamere">
                    <rsa-gestione-camere-list-component ref="cmpGestioneCamereList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-gestione-camere-list-component>
                </b-tab>
                <b-tab title="Storico Letti" id="storicoLetti">
                    <!-- <rsa-storico-letti-list-component ref="cmpStoricoLettiList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" /> -->
                    <rsa-gestione-camere-list-component ref="cmpGestioneStoricoList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-gestione-camere-list-component>
                </b-tab>
            </b-tabs>
        </template>
    </sa-page-layout>
</template>

<script>
import RsaGestioneCamereListComponent from "../components/RsaGestioneCamereListComponent.vue";
// import RsaStoricoLettiListComponent from "../components/RsaStoricoLettiListComponent.vue";
import saPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { saPageLayout, RsaGestioneCamereListComponent },
    mixins: { UtilityMixin },
    data() {
        return {
            showModalLoading: false,
            pathResourcePiani: "/rsapostilettopiani",
            pathResourceStanze: "/rsapostilettostanze",
            pathResourceSessi: "/rsapostilettostanzasessi",
            pathResourceStatoLetto: "/rsapostilettolettostati",
            pathResourceLetto: "/rsapostilettoletti",
            pathResourceStato: "/rsapostilettolettostati",
            path: null,
            idPiano: null,
            idStanza: null,
            sesso: null,
            pianiOptions: [],
            stanzeOptions: [],
            lettoOptions: [],
            activeTabIndex: 0,
            statoLettoOptions: [],
            sessoOptions: [],
            filtroGestioneCamere: { nomePiano: null, nomeStanza: null, nome: null, codiceSesso: null, statoAttuale: null },
            filtroGestioneCamereStorico: { nomePiano: null, nomeStanza: null, nomeLetto: null, codiceSesso: null, stato: null },
            filtroStanza: { idPiano: null },
            filtroLetto: { idStanza: null },
        };
    },

    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroGestioneCamere"]) {
            let filtro = JSON.parse(sessionStorage["filtroGestioneCamere"]);
            //console.log("Filtro recuperato da sessionStorage: ", filtro);
            if (Object.keys(filtro).length === 0) {
                filtro = { nomePiano: null, nomeStanza: null, nome: null, codiceSesso: null, statoAttuale: null };
            }
            me.filtroGestioneCamere = filtro;
            //console.log("Filtro Gestione Camere: ", me.filtroGestioneCamere);
        }
        me.loadDataPiani();
        me.loadDataSesso();
        me.loadDataStatoLetto();
        me.loadData();
    },
    /* computed: {
        statoFiltroCorrente: {
            get() {
                return this.activeTabIndex === 0 ? this.filtroGestioneCamere.statoAttuale : this.filtroGestioneCamereStorico.stato;
            },
            set(value) {
                if (this.activeTabIndex === 0) {
                    this.filtroGestioneCamere.statoAttuale = value;
                } else {
                    this.filtroGestioneCamereStorico.stato = value;
                }
            },
        },
    }, */
    methods: {
        loadData() {
            let me = this;
            me.activeTab(me.path);
        },
        loadDataStatoLetto() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStatoLetto, null, me.loadDataStatoLettoSuccess, me.loadDataStatoLettoError);
        },
        loadDataStatoLettoSuccess(response) {
            let me = this;
            me.statoLettoOptions = response.data.data.list;
        },
        loadDataStatoLettoError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento stati letto", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPiani() {
            let me = this;
            //console.log("Filtro Gestione Camere in load data Piani: ", me.filtroGestioneCamere);
            UtilityMixin.methods.loadDataResources(me.pathResourcePiani, {}, me.loadDataPianiSuccess, me.loadDataPianiError);
            // console.log("INIZIO CARICAMENTO PIANI");
        },
        loadDataPianiSuccess(response) {
            let me = this;

            /* me.pianiOptions = response.data.data.list; */
            if (response.data.data.list) {
                //console.log("RISPOSTA DEL METODO: ", response);
                //console.log("RISPOSTA DEL METODO: ", response.data.data.list);
                me.pianiOptions = response.data.data.list.map((piano) => ({ value: piano.nome, text: piano.nome, id: piano.id }));
                // console.log("SUCCESSO CARICAMENTO DATI CON PIANOOPTIONS = ", me.pianiOptions);
            } else {
                me.pianiOptions = [];
            }
            if (me.filtroGestioneCamere.nomePiano) {
                let selectedPiano = me.pianiOptions.find((item) => item.value === me.filtroGestioneCamere.nomePiano);
                //console.log("Piano selezioanto", selectedPiano);
                if (selectedPiano) {
                    me.filtroStanza = { idPiano: selectedPiano.id };
                    //console.log("Prova filtro Stanza", me.filtroStanza);
                    me.loadDataStanze();
                }
            }
            // console.log("pianiOptions nel loadPianoSuccess", me.pianiOptions);
        },
        loadDataPianiError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei piani", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataSesso() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSessi, null, me.loadDataSessoSuccess, me.loadDataSessoError);
        },
        loadDataSessoSuccess(response) {
            let me = this;
            me.sessoOptions = response.data.data.list;
            // console.log("pianiOptions nel loadSessoSuccess", me.sessoOptions);
        },
        loadDataSessoError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei sessi", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataStanze() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStanze, me.filtroStanza, me.loadDataStanzeSuccess, me.loadDataStanzeError);
            // console.log("Filtro in load stanza: ", me.filtroStanza);
        },
        loadDataStanzeSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.stanzeOptions = response.data.data.list.map((stanza) => ({
                    value: stanza.nome,
                    text: stanza.nome,
                    id: stanza.id,
                }));
            } else {
                me.stanzeOptions = [];
            }
            if (me.filtroGestioneCamere.nomeStanza) {
                let stanzaSelezionata = me.stanzeOptions.find((item) => item.value === me.filtroGestioneCamere.nomeStanza);
                if (stanzaSelezionata) {
                    //console.log("Stanza selezionata: ", stanzaSelezionata);
                    me.filtroLetto = {
                        idStanza: stanzaSelezionata.id,
                    };
                    me.loadDataLetti();
                }
            }

            // console.log("stanzaOptions: ", me.stanzeOptions);

            // console.log("stanzeOptions nel loadStanzeSuccess", me.stanzeOptions);
            //loadDataLetti();
        },
        loadDataStanzeError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle stanze", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        loadDataLetti() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceLetto, me.filtroLetto, me.loadDataLettiSuccess, me.loadDataLettiError);
        },
        loadDataLettiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                // console.log("RISPOSTA DEL METODO: ", response);
                me.lettoOptions = response.data.data.list.map((letto) => {
                    return { value: letto.nome, text: letto.nome, id: letto.id };
                });
            } else {
                me.lettoOptions = [];
            }

            // console.log("Operazione andata a buon fine: ", me.lettoOptions);
        },
        loadDataLettiError(response) {
            let me = this;

            me.$bvToast.toast("Errore durante il caricamento dei dati: ", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onChangePiano(nome) {
            let me = this;
            let selectedPiano = me.pianiOptions.find((piano) => piano.value === nome);
            me.filtroGestioneCamere.nomeStanza = null;
            // console.log("VALORE PARAMENTRO DEL METODO onChangePiano", nome);
            me.filtroGestioneCamere.nome = null;
            me.stanzeOptions = [];
            me.lettoOptions = [];
            // me.pianiOptions.forEach((element) => {
            //     if (nome === element.nome) {
            //         me.filtro.idPiano = element.id;
            //         selectedPiano= element
            //     }
            // });
            if (selectedPiano) {
                me.filtroStanza = { idPiano: selectedPiano.id };
                me.loadDataStanze();
                // me.loadData();
                // console.log("ENTRO NEL IF DI CHANGEPIANO");
            }
            me.idPiano = me.filtroStanza.idPiano;
            //me.filtroLetto = { idPiano: null, sesso: null, idStanza: null };
            // console.log("me.filtroStanza in onChangePiano: ", me.filtroStanza);
            // console.log("me.filtroLetto in onChangePiano: ", me.filtroLetto);
        },
        onChangeStanza(value) {
            let me = this;
            let selectedStanza = me.stanzeOptions.find((stanza) => stanza.value === value);

            me.filtroGestioneCamere.nome = null;
            me.lettoOptions = [];
            // console.log("SONO NEL METODO");

            if (selectedStanza) {
                me.filtroLetto = { idStanza: selectedStanza.id };
                me.loadDataLetti();
            }
            // console.log("me.filtroLetto in onChangeStanza: ", me.filtroLetto);
        },
        onChangeSesso(codiceSesso) {
            let me = this;
            let selectedSesso = me.sessoOptions.find((sesso) => sesso.codice === codiceSesso);
            if (selectedSesso) {
                me.filtroStanza = { idPiano: me.idPiano, sesso: selectedSesso.codice };
            }
            me.sesso = me.filtroStanza.sesso;
        },
        //onChangeLetto(value) {
        //  let me = this;
        //  let selectedLetto = me.lettoOptions.find((letto) => letto.nome === value);
        //  if (selectedLetto) {
        //      me.filtroLetto = { idPiano: me.idPiano, sesso: me.sesso, idStanza: me.idStanza };
        //  }
        //  me.nomeLetto = me.filtroLetto.nome;
        //  // console.log("me.filtroLetto in onChangeLetto: ", me.filtroLetto);
        //  // console.log("me.filtroGestioneCamere in onChangeLetto: ", me.filtroGestioneCamere);
        //},

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;

            switch (me.activeTabIndex) {
                case 0:
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
                    // console.log("dentro il tab 0");
                    // console.log("FILTRO LETTO: ", me.filtroGestioneCamere);
                    me.onChangeTab(me.activeTabIndex);
                    // console.log("----");
                    break;
                case 1:
                    // console.log("FILTRO STORICO: ", me.filtroGestioneCamere);
                    me.filtroGestioneCamereStorico = { nomeStanza: me.filtroGestioneCamere.nomeStanza, nomePiano: me.filtroGestioneCamere.nomePiano, codiceSesso: me.filtroGestioneCamere.codiceSesso, stato: me.filtroGestioneCamere.statoAttuale, nome: me.filtroGestioneCamere.nome };
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamereStorico);
                    // console.log("FILTRO LETTO: ", me.filtroGestioneCamereStorico);
                    me.onChangeTab(me.activeTabIndex);
                    // console.log("dentro il tab 1", me.activeTabIndex);
                    break;
            }
        },
        onReset() {
            let me = this;
            me.filtroGestioneCamere = { nomePiano: null, nomeStanza: null, codiceSesso: null, statoAttuale: null, nome: null };
            me.idPiano = null;
            me.sesso = null;
            me.stanzeOptions = [];
            me.lettoOptions = [];
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
            me.onChangeTab(me.activeTabIndex);
            // console.log("ACTIVE INDEX: ", me.activeTabIndex);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onChangeTab(index) {
            let me = this;
            let indexTab = me.$refs.tabsGestioneCamere.getTabs()[index];
            me.activeTab(indexTab.id);
            /*  console.log("index", index);
            console.log("indexTab", indexTab.id); */
        },
        activeTab(idIndexTab) {
            let me = this;
            let path = "";
            let sessionStorage = window.sessionStorage;
            switch (idIndexTab) {
                case "gestioneCamere":
                    path = "/rsapostilettoletti";
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamere);
                    me.$refs.cmpGestioneCamereList.setParametri(path);
                    break;
                case "storicoLetti":
                    path = "/rsapostilettolettostatistorico";
                    me.filtroGestioneCamereStorico = { nomeStanza: me.filtroGestioneCamere.nomeStanza, nomePiano: me.filtroGestioneCamere.nomePiano, codiceSesso: me.filtroGestioneCamere.codiceSesso, stato: me.filtroGestioneCamere.statoAttuale, nome: me.filtroGestioneCamere.nome };
                    sessionStorage["filtroGestioneCamere"] = JSON.stringify(me.filtroGestioneCamereStorico);
                    me.$refs.cmpGestioneStoricoList.setParametri(path);
                    break;
                default:
                    path = "/rsapostilettoletti";
                    me.$refs.cmpGestioneCamereList.setParametri(path);
                    break;
            }
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
